<script lang="ts">
    import CategoryList from "./CategoryList.svelte";
    import { fade } from 'svelte/transition';

    export let categoryData = [];
    export let sub = false;
    let hoverKey = ''

    function onHover(key) {
        hoverKey = key;
    }
</script>


<div class="category-menu {sub ? 'sub-menu' : ''}">
    <ul class="{sub ? 'sub-menu' : ''}">
        {#each categoryData as category }
            <li class="{category.categories !== undefined ? 'sub-menu' : ''}">
                <a href="{category.link}"
                   on:mouseenter={onHover(category.key)}
                   on:mouseleave={onHover(null)}>{category.name}
                </a>
                {#if category.categories !== undefined && hoverKey === category.key}
                    <div transition:fade>
                        <CategoryList categoryData={category.categories} sub={true}></CategoryList>
                    </div>
                {/if}
            </li>
        {/each}
    </ul>
</div>

<style>
    ul.sub-menu {
        position: absolute;
        left: 99.999999%;
        top: 0;
        display: none;
        z-index: 99999;
        background: #fff;
    }

    li.sub-menu:before {
        content: "\f105";
        font-family: 'FontAwesome',serif;
        color: #888888;
        margin: 0;
        font-size: 14px;
        position: absolute;
        right: 20px;
        line-height: 40px;
    }

    .category-menu {
        width: 270px;
        background: #fff;
        border-top: 0;
        top: 100%;
        margin-top: 54px;
    }

    .category-menu.sub-menu {
        margin: 0;
    }

    .category-menu ul {
        margin: 0;
        display: inline-block;
        width: 100%;
        border-top: 0;
        padding: 10px 0 9px;
    }

    .category-menu li {
        width: 100%;
        position: relative;
        text-align: left;
    }

    .category-menu li a {
        padding: 0 20px;
        font-size: 14px;
        letter-spacing: 0;
        font-weight: 500;
        display: inline-block;
        width: 100%;
        line-height: 40px;
        color: #555;
        outline: 0;
    }

    ul {
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 40px;
    }

    li {
        list-style: none;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .category-menu {
            width: 250px;
        }
    }
</style>
